'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Get the current year
 * @example getTime() => 2021
 * @param date Date | string | undefined
 * @returns number
 */ const getCurrentYear = (date)=>{
    return date ? new Date(date).getFullYear() : new Date().getFullYear();
};

exports.getCurrentYear = getCurrentYear;
//# sourceMappingURL=year.js.map
